import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './index.css';

import { HasVideoBadge } from '../../../common/components/has_video_badge';
import { Photo } from '../../../common/components/photo';
import { PromoInfo } from '../../../common/components/promo_info';
import { IOffer } from '../../../types/offer';
import { isArrayWithItems } from '../../../utils/index';
import { IPhotosTracking } from './tracking';
import { IOfferCardAPI } from '../..';
import { OfferLabels } from '../../../common/components/offer_labels';
import { PhotoLabels } from '../PhotoLabels';
import { IPhotoLabel } from '../../../types/photoLabels';
import { HasTourBadge } from '../../../common/components/HasTourBadge';

export interface IPhotosProps extends Partial<IPhotosTracking> {
  offer: IOffer;
  galleryControlsHidden: boolean;
  photoContainerStyle?: string;
  layoutPhotoStyle?: string;
  /** Использовать ли в галерее фото более высокого качества */
  useThumbnail2Url?: boolean;
  offerCardApi?: IOfferCardAPI;
  isOfferInSavedSearch?: boolean;
}

export interface IPhotosState {
  isPhotoSlideChanged: boolean;
}

export class Photos extends React.Component<IPhotosProps, IPhotosState> {
  public state = {
    isPhotoSlideChanged: false,
  };

  public render() {
    const {
      offer,
      galleryControlsHidden,
      photoContainerStyle,
      layoutPhotoStyle,
      useThumbnail2Url,
      isOfferInSavedSearch,
    } = this.props;

    const hasVideo = isArrayWithItems(offer.videos);
    const isNewbuildingTourAvailable = offer.isNewbuildingTourAvailable;

    /**
     * Показываем лейблы только в случае если:
     *  - находимся на обычной выдаче (не сохраненный поиск)
     *  - отсутствует промо лейбл
     */
    const isShowPhotoLabels = offer.photoLabels
      && offer.photoLabels.length > 0
      && !isOfferInSavedSearch
      && !offer.promoInfo;

    return (
      <div {...mergeStyles(styles['container'], photoContainerStyle)}>
        {
          offer.savedSearchLabels && offer.savedSearchLabels.length > 0 &&
          <OfferLabels offersList={offer.savedSearchLabels} />
        }
        {
          offer.promoInfo && !isOfferInSavedSearch &&
            <PromoInfo
              containerStyle={mergeStyles(
                styles['promo-container'],
                offer.isNew && styles['promo-container-isnew'],
              )}
              isSpecProject={offer.promoInfo.specProject}
              name={offer.promoInfo.name}
              href={offer.fullUrl}
            />
        }
        <div className={ styles['badges-container'] }>
          {
            isNewbuildingTourAvailable && <HasTourBadge />
          }
          {
            hasVideo && <HasVideoBadge />
          }
        </div>
        {isShowPhotoLabels && (
          <PhotoLabels labels={offer.photoLabels as IPhotoLabel[]} hasVideo={hasVideo} />
        )}
        <Photo
          containerStyle={styles['photos']}
          controlButtonsFullHeight={true}
          photos={offer.photos}
          galleryControlsHidden={galleryControlsHidden}
          onSlideChanged={this.handlePhotoSlideChangedOnce}
          hasLayoutPhoto={offer.fromDeveloper}
          layoutPhotoStyle={layoutPhotoStyle}
          useThumbnail2Url={useThumbnail2Url}
        />
      </div>
    );
  }

  private handlePhotoSlideChangedOnce = () => {
    const { trackPhotoSlideChanged } = this.props;
    const { isPhotoSlideChanged } = this.state;

    if (!isPhotoSlideChanged) {
      if (trackPhotoSlideChanged) {
        trackPhotoSlideChanged();
      }
      this.setState({
        isPhotoSlideChanged: true,
      });
    }
  }
}
